import React from 'react';
import PastImageItem from '../PastImageItem';
import usePastImagesPricelists from '../../hooks/usePastImagesPricelists';
import usePastImages from '../../hooks/usePastImages';
import { useEmailInterceptor } from '../EmailInterceptor/EmailInterceptor';
import Spinner from '../Spinner';

export default function PastImageItems({ student, onContinue, query = {} }) {
  const { isLoading: isLoadingPastImages, data: pastImages } = usePastImages({ studentId: student.id, additionalQuery: query });
  const { isLoading: isLoadingPricelists, data: pricelists } = usePastImagesPricelists();
  const { intercept } = useEmailInterceptor();

  if (isLoadingPastImages || isLoadingPricelists) return <div style={{ margin: '0 auto' }}><Spinner color="blue" /></div>;
  if (pricelists.length === 0) return null;

  return (
    <>
      {(pastImages || []).map((studentImage) => {
        const pricelist = pricelists.find((p) => studentImage.folder.includes(p.season));

        if (!pricelist) return null;

        const onClick = () => intercept(() => onContinue({ packageId: pricelist.id, studentImage }));

        return (
          <PastImageItem
            key={studentImage.id}
            student={student}
            pricelist={pricelist}
            studentImage={studentImage}
            onClick={onClick}
          />
        );
      })}
    </>
  );
}
